import { render, staticRenderFns } from "./UserDrawerHeader.vue?vue&type=template&id=513f156e&scoped=true&"
import script from "./UserDrawerHeader.vue?vue&type=script&lang=js&"
export * from "./UserDrawerHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserDrawerHeader.vue?vue&type=style&index=0&id=513f156e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f156e",
  null
  
)

export default component.exports